import { useEffect, useRef } from 'react'
// 首页工作台
import WorkBench from './IndexWorkbench'

import './css/Index.css'

export default function Index(props: any) {

    const containerRef = useRef<any>(null)

    return (<div className="commons-page" ref={containerRef}>
        {/* 首页 -> 首页 -> 概览 */}
        <WorkBench dd={(val: any) => {
            props.dd(val)
        }} />
    </div>)
}